import React from "react";
import { MessagesComponentProps, Message, Messages } from "./types"; // Asegúrate de importar correctamente AlertCard desde su ubicación correcta en tu proyecto
import { AlertCard } from "@letsbit/milkylb";
import classNames from "classnames";

const MessageWithLinks: React.FC<Message> = ({ message }) => {
  // Expresión regular para buscar URLs
  const regex = /(https?:\/\/[^\s]+)/g;
  // Dividir el mensaje en parts que no son enlaces
  const messageParts = message.split(regex);

  return (
    <>
      {messageParts.map((part, index) => {
        if (part.match(regex)) {
          // Si la part es un enlace, devolver un enlace con target="_blank"
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              className="underline hover:text-[var(--milkylb-color-secondary-400)]"
            >
              {part}
            </a>
          );
        } else {
          // Si la part no es un enlace, devolver el texto normal
          return part;
        }
      })}
    </>
  );
};

const MessagesWithLinks: React.FC<Messages> = ({
  messages,
  alertCardClassname,
}) => {
  return (
    <>
      {messages.map((message, index) => (
        <AlertCard
          text={<MessageWithLinks key={index} message={message} />}
          className={classNames(alertCardClassname, "items-center")}
        />
      ))}
    </>
  );
};

const MessagesComponent: React.FC<MessagesComponentProps> = ({
  messages,
  alertCardClassname,
}) => {
  return messages && messages.length > 0 ? (
    <MessagesWithLinks
      messages={messages}
      alertCardClassname={alertCardClassname}
    />
  ) : null;
};

export default MessagesComponent;
